import type { IRecipient } from "./types";

import { atom } from "recoil";

export const RecipientLocalState = atom<IRecipient[]>({
  key: "selected-recipients-user-local-state-key",
  default: [],
});


export const IsRecipientLoading = atom<boolean>({
  key: "is-recipient-loading",
  default: false,
});

export const RecipientErrorsState = atom<{ [key: string]: string[] }>({
  key: "recipients-error-state",
  default: {},
});

export const AccessCodeErrorsState = atom<{ [recipientId: string]: boolean }>({
  key: "access-code-errors-state",
  default: {},
});
